module.exports = __webpack_public_path__ + "resources/img/ico_select_arrow.00a71498f8e193fc5838de93d8974ebc.png";